import ReducerBuilder from 'classes/ReducerBuilder';
import masterSearchBarInitialState from './initialState';
import {Types} from './actions';

export default ReducerBuilder.make(masterSearchBarInitialState)
  .forType(Types.SEARCH_QUERY_CHANGED).reduce((state, actions) => {
    state.searchQuery = actions.searchQuery;
    state.fetching = true;
  })
  .forType(Types.RECEIVED_SEARCH_RESULTS).reduce((state, {searchResults}) => {
    state.searchResults = searchResults;
    state.fetching = false;
  })
  .forType(Types.CLEAR_SEARCH_RESULTS)
  .reduce((state, action) => {
    state.searchQuery = null;
    state.searchResults.length = 0;
  })
  .build();



// WEBPACK FOOTER //
// ./public/components/MasterSearchBar/reducer.js